import * as types from './mutation_types'

export default {
  setDaysFilterTemplateId: async ({ commit, rootGetters }, id) => {
    commit(types.SET_DAYS_FILTER_TEMPLATES_ID, id)
  },
}
